import { Injectable } from "@angular/core";
import { map } from "rxjs";
import { HttpService } from "../../../share-modul/services/common/http-service";
import { environment } from 'src/environments/environment';
import { SearchAdministratorModel } from "../../models/system-profiles/search-administrator.model";
import { DeleteAdministratorModel } from "../../models/system-profiles/delete-administrator.model";
import { SearchTechSupportModel } from "../../models/system-profiles/search-tech-support.model";
import { HttpClient, HttpHeaders, HttpRequest } from "@angular/common/http";
import { UserProfileModel } from "../../models/system-profiles/user-profile.model";
import { DatePipe } from "@angular/common";
import { TechSupportModel } from "../../models/system-profiles/tech-support.model";


const ADM_API = environment.apiURL + '/api/adm/Administrator/';
const TECH_API = environment.apiURL + '/api/adm/TechSupport/'
const USER_API = environment.apiURL + '/api/adm/User/';
const COMPANY_API = environment.apiURL + '/api/adm/Company/';
@Injectable({
    providedIn: 'root'
})
export class AdministratorService {
    //#region Fields
    //#endregion

    //#region Constructor

    constructor(private _httpService: HttpService, private _httpClient: HttpClient) {
    }
    //#endregion

    //#region Public Methods

    getuserprofile() {
        var url = USER_API + "getuserprofile";
        return this._httpService.httpGet(url)
            .pipe(map(resposne => {
                return resposne;
            }));
    }

    updateuserprofile(model: UserProfileModel, file: any) {
        var url = USER_API + "updateuserprofile";
        const formData: FormData = new FormData();
        formData.append('FirstName', model.firstName as string)
        formData.append('LastName', model.lastName as string)
        formData.append('Phone', model.phone as string)
        const datepipe: DatePipe = new DatePipe('en-US')
        let formattedDate = datepipe.transform(model.dateOfBirth, 'MM/dd/yyyy')
        formData.append('DateOfBirth', formattedDate as string)
        formData.append('profileImage', file as string)
        return this._httpClient
            .post<any>(url, formData)
            .pipe(map(resposne => {
                return resposne;
            }));
    }

    getAllAdmins(model: SearchAdministratorModel) {
        var url = ADM_API + "getalladmins";
        return this._httpService.httpPost(url, model)
            .pipe(map(resposne => {
                return resposne;
            }));
    }
    addAdmin(model: UserProfileModel, file: any) {
        var url = ADM_API + "addadmin";
        const formData: FormData = new FormData();
        formData.append('Email', model.email as string)
        formData.append('FirstName', model.firstName as string)
        formData.append('LastName', model.lastName as string)
        formData.append('Phone', model.phone as string)
        const datepipe: DatePipe = new DatePipe('en-US')
        let formattedDate = datepipe.transform(model.dateOfBirth, 'MM/dd/yyyy')
        formData.append('DateOfBirth', formattedDate as string)
        formData.append('CompanyId', model.companyId as string)
        formData.append('LanguageId', localStorage.getItem('languageId') as string)
        formData.append('profileImage', file as string)
        return this._httpClient
            .post<any>(url, formData)
            .pipe(map(resposne => {
                return resposne;
            }));
    }
    updateAdmin(model: UserProfileModel, file: any) {
        var url = ADM_API + "updateadmin";
        const formData: FormData = new FormData();
        formData.append('AdminId',model.adminId as string)
        formData.append('Email', model.email as string)
        formData.append('FirstName', model.firstName as string)
        formData.append('LastName', model.lastName as string)
        formData.append('Phone', model.phone as string)
        const datepipe: DatePipe = new DatePipe('en-US')
        let formattedDate = datepipe.transform(model.dateOfBirth, 'MM/dd/yyyy')
        formData.append('DateOfBirth', formattedDate as string)
         formData.append('CompanyId', model.companyId as string)
        formData.append('LanguageId', localStorage.getItem('languageId') as string)
        formData.append('profileImage', file as string)
        return this._httpClient
            .post<any>(url, formData)
            .pipe(map(resposne => {
                return resposne;
            }));
    }
    deleteAdmin(model: DeleteAdministratorModel) {
        var url = ADM_API + "deleteadmin";
        return this._httpService.httpPost(url, model)
            .pipe(map(resposne => {
                return resposne;
            }));
    }


    getAllTechSupport(model: SearchTechSupportModel) {
        var url = TECH_API + "getallsuperadmins";
        return this._httpService.httpPost(url, model)
            .pipe(map(resposne => {
                return resposne;
            }));
    }
    getAllCompanyNames() {
        var url = COMPANY_API + "getallcompanynames";
        return this._httpService.httpGet(url)
            .pipe(map(resposne => {
                return resposne;
            }));
    }
    getadminbyid(id: string) {
        var url = ADM_API + 'getadmin?adminId=' + id;
        return this._httpService.httpGet(url)
            .pipe(map(resposne => {
                return resposne;
            }));
    }

    getsuperadminbyid(id: string) {
        var url = TECH_API + 'getsuperadmin?id=' + id;
        return this._httpService.httpGet(url)
            .pipe(map(resposne => {
                return resposne;
            }));
    }
    updatesuperadmin(model: TechSupportModel, file: any) {
        var url = TECH_API + "updatesuperadmin";
        const formData: FormData = new FormData();
        formData.append('AdminId',model.id as string)
        formData.append('Email', model.email as string)
        formData.append('FirstName', model.firstName as string)
        formData.append('LastName', model.lastName as string)
        formData.append('Phone', model.phone as string)
        const datepipe: DatePipe = new DatePipe('en-US')
        let formattedDate = datepipe.transform(model.dateOfBirth, 'MM/dd/yyyy')
        formData.append('DateOfBirth', formattedDate as string)       
        formData.append('LanguageId', localStorage.getItem('languageId') as string)
        formData.append('profileImage', file as string)
        return this._httpClient
            .post<any>(url, formData)
            .pipe(map(resposne => {
                return resposne;
            }));
    }
    addsuperadmin(model: TechSupportModel, file: any) {
        var url = TECH_API + "addsuperadmin";
        const formData: FormData = new FormData();
        formData.append('Email', model.email as string)
        formData.append('FirstName', model.firstName as string)
        formData.append('LastName', model.lastName as string)
        formData.append('Phone', model.phone as string)
        const datepipe: DatePipe = new DatePipe('en-US')
        let formattedDate = datepipe.transform(model.dateOfBirth, 'MM/dd/yyyy')
        formData.append('DateOfBirth', formattedDate as string)       
        formData.append('LanguageId', localStorage.getItem('languageId') as string)
        formData.append('profileImage', file as string)
        return this._httpClient
            .post<any>(url, formData)
            .pipe(map(resposne => {
                return resposne;
            }));
    }
   
    deleteTechSupport(model: DeleteAdministratorModel) {
        var url = TECH_API + "deletesuperadmin";
        return this._httpService.httpPost(url, model)
            .pipe(map(resposne => {
                return resposne;
            }));
    }
    //#endregion
}